import { fetcher } from '@commenda/utils';

import { IApiResponse } from './types';

export interface IBatchDeleteFilePlacementsParams {
  filePlacementIds: string[];
}

export async function batchDeleteFilePlacements({
  filePlacementIds,
}: IBatchDeleteFilePlacementsParams): Promise<IApiResponse<null>> {
  const response = await fetcher('drive-view/file-placement/delete/bulk', {
    method: 'DELETE',
    body: { filePlacementIds },
  });

  if (!response.ok) {
    const body = await response.json().catch(() => ({}));
    return {
      success: false,
      error: body?.message || 'Failed to delete placements',
      statusCode: response.status,
      data: null,
    };
  }

  return {
    success: true,
    error: null,
    statusCode: response.status,
    data: null,
  };
}
